module.exports = __webpack_public_path__ + "img/cch4.2f4e00f8.jpg";